import { createFileRoute } from '@tanstack/react-router'
import { useMutation } from '@tanstack/react-query'
import { api, call } from '../../lib/api'
import { FormError } from '../../components/auth'
import { Button, Card, Field, Input, PageHeader, toast } from '../../components/ui'

export const Route = createFileRoute('/_app/support')({ component: Support })

const FAQ = [
  ['How does a customer get a refill order automatically?', "When a customer's meter reports that their gas is at or below the trigger level on their profile, GasRail raises a pending refill order, notifies your admins by email and shows it in Orders."],
  ['How do I connect a new meter?', 'Open the customer (or outlet tank), choose Edit, and enter the 16-character DevEUI printed on the meter. Meters that report before being linked show up under Settings → Meters.'],
  ['Where do readings come from?', 'Your LoRaWAN network server forwards each uplink to the ingest URL in Settings → API Keys, authenticated with your secret key.'],
  ['How are prices calculated?', 'Customer refills use your retail price per kg; outlet deliveries use your wholesale price. Both are in Settings → Business.'],
] as const

function Support() {
  const send = useMutation({
    mutationFn: (f: FormData) => call(api.support.$post({ json: { subject: String(f.get('subject')), message: String(f.get('message')) } })),
    onSuccess: () => toast("Message sent. We'll reply by email."),
  })
  return (
    <div>
      <PageHeader title="Support" subtitle="Answers to common questions, or write to the GasRail team." />
      <div className="grid gap-8 lg:grid-cols-[1fr_400px]">
      <section>
        <div className="space-y-3">
          {FAQ.map(([q, a]) => (
            <details key={q} className="group rounded-card bg-card p-5 open:bg-white">
              <summary className="cursor-pointer list-none text-sm font-semibold marker:hidden">{q}</summary>
              <p className="mt-3 text-sm leading-6 text-ink-2">{a}</p>
            </details>
          ))}
        </div>
      </section>
      <Card className="h-fit bg-white p-6">
        <h2 className="font-semibold">Contact us</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            const form = e.currentTarget
            send.mutate(new FormData(form), { onSuccess: () => form.reset() })
          }}
          className="mt-4 space-y-4"
        >
          <FormError error={send.error?.message} />
          <Field label="Subject"><Input name="subject" required maxLength={160} /></Field>
          <Field label="Message"><textarea name="message" required rows={6} maxLength={5000} className="w-full rounded-lg border border-line bg-white p-3 text-sm focus:border-brand focus:outline-none" /></Field>
          <Button className="w-full" disabled={send.isPending}>{send.isPending ? 'Sending…' : 'Send message'}</Button>
        </form>
      </Card>
      </div>
    </div>
  )
}
